import React, { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Header, TextInput, Button } from 'components/common'

interface OnboardFormStateType {
  companyName: string
  companyUrl: string
  streetAddress: string
  aptNumber: string
  city: string
  stateProvince: string
  zipPostalCode: string
  errors: {
    companyName?: string
    companyUrl?: string
    streetAddress?: string
    city?: string
    stateProvince?: string
    zipPostalCode?: string
  }
}

interface Step3Props {
  state: OnboardFormStateType
  localDispatch: React.Dispatch<any>
  onSubmit: (e: FormEvent) => void
  submitting: boolean
  canProceed: boolean
}

export const Step3 = ({
  state,
  localDispatch,
  onSubmit,
  submitting,
  canProceed,
}: Step3Props) => {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes.signUp',
  })

  return (
    <div className="form-step">
      <Header as="h3">{t('companyDetails', 'Company Details')}</Header>
      <div className="onboard-message">{t('allRequired')}</div>

      <TextInput
        id="company-name"
        label={t('companyName', 'Company Name')}
        placeholder=""
        value={state.companyName}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'companyName',
          })
        }
        fullBorder
        error={state.errors.companyName}
      />
      <TextInput
        id="company-url"
        label={t('companyURL', 'Company URL')}
        placeholder="https://example.com"
        value={state.companyUrl}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'companyUrl',
          })
        }
        fullBorder
        error={state.errors.companyUrl}
      />
      <TextInput
        id="street-address"
        label={t('streetAddress', 'Street Address')}
        placeholder=""
        value={state.streetAddress}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'streetAddress',
          })
        }
        fullBorder
        error={state.errors.streetAddress}
      />
      <TextInput
        id="apt-number"
        label={t('aptNumber', 'Apartment / Suite/ etc')}
        placeholder=""
        value={state.aptNumber}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'aptNumber',
          })
        }
        fullBorder
      />
      <TextInput
        id="city"
        label={t('city', 'City')}
        placeholder=""
        value={state.city}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'city',
          })
        }
        fullBorder
        error={state.errors.city}
      />
      <TextInput
        id="state-province"
        label={t('stateProvince', 'State / Province / Region')}
        placeholder=""
        value={state.stateProvince}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'stateProvince',
          })
        }
        fullBorder
        error={state.errors.stateProvince}
      />
      <TextInput
        id="zip-postal-code"
        label={t('zipPostalCode', 'Postal / Zip Code')}
        placeholder=""
        value={state.zipPostalCode}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          localDispatch({
            type: 'SET_INPUT',
            value,
            input: 'zipPostalCode',
          })
        }
        fullBorder
        error={state.errors.zipPostalCode}
      />

      <div className="step-navigation">
        <Button
          color="blue"
          onClick={onSubmit}
          loading={submitting}
          disabled={!canProceed}
        >
          {t('submitCompanyProfile', 'Submit Company Profile')}
        </Button>
      </div>
    </div>
  )
}
